export const tutorMonthlyScoreConstants = {
    HIDE_RESET_MODAL: "HIDE_RESET_MODAL",
}
